import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import ToHomeButton from './ToHomeButton';
import { BackendStatus, checkBackend } from '../../utils/checkBackend';

function Hamburger() {
  const [isOpen, setIsOpen] = useState(false);
  const [backendAlive, setBackendAlive] = useState(null);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleCheckBackend = () => {
    checkBackend(setBackendAlive);
  };

  return (
    <div className="fixed top-4 left-4 z-50">
      <button
        onClick={toggleMenu}
        className="btn btn--small bg-gray-800 text-white hover:bg-gray-700"
      >
        {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
      </button>

      {isOpen && (
        <div className="absolute top-12 left-0 bg-white border border-gray-300 rounded shadow-lg p-4 flex flex-col gap-3 min-w-max">
          <div>
            <ToHomeButton buttonText="ホームへ" />
          </div>
          <div className="border-t pt-3">
            <BackendStatus backendAlive={backendAlive} onCheck={handleCheckBackend} />
          </div>
        </div>
      )}
    </div>
  );
}

export default Hamburger;
